// authApi.js
import { API_CONFIG} from "../../utils/api-config";
import fetchWithAuth from "../../utils/apiAthurization";

export const StoreArea = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/masters/areas`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const BulkImportArea = async (data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/masters/areas/bulk-import`,'POST',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetAreas = async (cityId) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/masters/areas?cityId=${cityId}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "areas fetching failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const GetAreaById = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/masters/areas/${id}`
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const UpdateArea = async (id,data) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/masters/areas/${id}`,'PATCH',data
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};

export const DeleteArea = async (id) => {
  try {
    const response = await fetchWithAuth(
      `${API_CONFIG.baseURL}/masters/areas/${id}`,'DELETE'
    );
    return response.data; // Axios automatically parses JSON
  } catch (error) {
    // throw new Error(error?.message || "Login failed");
    return { 
      status: "error", 
      message: error?.message || "signup failed",
      statusCode: error.response?.status || 500 // Preserve status code
    };
  }
};